import { TextStyle, ViewStyle } from "react-native";
import { ILabelStyle } from "@fkhplus/common/src/components/atoms/Text/Label";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export interface ItextStyle extends ILabelStyle, TextStyle {
}

export enum IconPosition {
    Right,
    Left
}

export type ButtonTypes = 'primary' | 'secondary' | 'disable' | 'primaryLight' | 'secondaryLight' | 'light' | undefined

export interface IButtonProps {
    testId?: string;
    title?: string;
    onPress?: () => void;
    onPressIconRight?: () => void;
    onPressIconLeft?: () => void;
    disabled?: boolean;
    containerStyles?: ViewStyle;
    textStyle?: ItextStyle;
    iconName?: string;
    iconPosition?: IconPosition;
    iconColor?: string;
    iconSize?: number;
    iconStyle?: ViewStyle;
    multiColorIconLeft?: React.ReactElement;
    multiColorIconRight?: React.ReactElement;
    buttonType?: ButtonTypes;
    description?: string;
    borderRadius?: number;
    descriptionStyle?: ILabelStyle;
}